import React from "react"

import { AppSitesAutocomplete } from "@components"
import { useUserSettingsSite, useUserSettingsSiteValidator } from "../../../@hooks"
import { userSettingSitesFormData } from "../../../@signals"


export default function UserSettingSiteDrawerSites() {
	const { handleChangeSitesFormData } = useUserSettingsSite()
	const { siteError } = useUserSettingsSiteValidator()

    return <AppSitesAutocomplete
		label="Site"
		disableClearable
		multiple={false}
		placeholder="Select site"
		error={siteError}
		value={userSettingSitesFormData.value?.id_site || ''}
		onChange={e => handleChangeSitesFormData(e.target.value, 'id_site')}
	/>
}